<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="模板过户结果"
  >
    <div class="content" v-if="data">
      <div class="row" v-for="item in data" :key="item.ym">
        <div class="name">{{ item.ym }}</div>
        <div class="label">{{ item.reason }}</div>
      </div>
    </div>
    <!-- <div class="foot">
      <Button @click="onCancel">取消</Button>
    </div> -->
  </Modal>
</template>
<script>
export default {
  name: "transferListModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
</style>
